import { Droplet, Minus, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";

export const WaterCard = ({ date, ml = 0, goal, onChanged }) => {
  const set = async (v) => {
    try {
      await api.put(`/nutri/water/${date}`, { ml: Math.max(0, v) });
      onChanged();
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  const glasses = Math.max(8, Math.ceil(goal / 250));
  const filled = Math.floor(ml / 250);

  return (
    <section data-testid="water-card" className="border border-[rgba(152,191,162,0.15)] bg-[#0b120e] p-6">
      <div className="flex items-center justify-between">
        <p className="eyebrow">Acqua</p>
        <Droplet size={16} className="text-[#98bfa2]" />
      </div>
      <p className="mt-3 font-display text-5xl font-900"><span data-testid="water-ml">{ml}</span><span className="text-xl text-[#a3b1aa]"> / {goal} ml</span></p>
      <div className="my-5 grid grid-cols-8 gap-1.5">
        {Array.from({ length: glasses }).map((_, i) => (
          <button key={i} data-testid={`water-glass-${i}`} onClick={() => set((i + 1) * 250)} aria-label={`${(i + 1) * 250} ml`}
            className={`h-8 transition-colors ${i < filled ? "bg-[#98bfa2]" : "bg-white/10 hover:bg-white/20"}`} />
        ))}
      </div>
      <div className="flex gap-2">
        <button data-testid="water-minus-btn" onClick={() => set(ml - 250)} className="grid h-11 w-11 place-items-center border border-white/15 hover:border-[#c4dcca]" aria-label="Meno acqua"><Minus size={16} /></button>
        <button data-testid="water-plus-btn" onClick={() => set(ml + 250)} className="flex flex-1 items-center justify-center gap-2 bg-[#98bfa2] font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca]">
          <Plus size={16} /> 1 bicchiere
        </button>
      </div>
    </section>
  );
};
